export const FEACH_PARAMS = {
  // immediatelyBuy: false,
  verticalTag: "cn_ybxt_b2c",
  clientVersion: "1.0.0",
  client: "pc",
  lang: "zh_CN",
  isPresale: false,
  ptFlag: false,
  uniformBizInfo: {
    tenantId: 1,
    buId: 405,
    channelId: 0,
    ua: 4,
  },
};
export const USERBESTCOUPON = false;
